//记得在 src\components\lang\zhLoad.js 里面添加对象
const userPoints = {
  userName: '用户',
  areaName: '大区',
  cityName: '城市',
  customerName: '经销商',
  clockInPoints: '总积分',
  availablePoints: '剩余可用积分',
  exchangePointsCount: '兑换次数',
  msg: {}
};
export default userPoints



// WEBPACK FOOTER //
// ./src/page/pointsManagement/userPoints/lang/userPoints.en.js